import {put, takeEvery} from 'redux-saga/dist/redux-saga-effects-npm-proxy.esm';
import {TYPES as USER_ALBUM_TYPE} from '../creators/user.album';

//TODO: REMPLACER PAR "redux-saga/effects"

export function* createSuccess(action) {
    try {
        yield put({type: "USER_ALBUMS_ADD", data: action.payload});
    } catch (error) {

    }
}

export function* deleteSuccess(action) {
    try {
        yield put({type: "USER_ALBUMS_DELETE", data : action.payload});
    } catch (error) {

    }
}

export function* updateSuccess(action) {
    try {
        yield put({type: "USER_ALBUMS_UPDATE", data : action.payload});
    } catch (error) {

    }
}

export function* watchAlbum() {
    yield takeEvery(USER_ALBUM_TYPE.CREATE_SUCCESS, createSuccess);
    yield takeEvery(USER_ALBUM_TYPE.DELETE_SUCCESS, deleteSuccess);
    yield takeEvery(USER_ALBUM_TYPE.UPDATE_SUCCESS, updateSuccess);
}

export default watchAlbum;

